import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import * as stockActions from '../modules/stock';
import * as baseActions from '../modules/base';

import { useShortCut } from "Hook/useShortCut";
import { useOutsideHandler } from "Hook/useOutsideHandler";

import SwiperCore, { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import IssueChart from "Components/Chart/IssueChart";
import SearchChart from "Components/Chart/SearchChart";

import util from 'util/baseUtil';


SwiperCore.use([Navigation, Pagination]);
const Tab = {
  DART: 'dart',
  NEWS: 'news',
}
const ChartRange = {
  MONTH1: '1m',
  MONTH3: '3m',
  MONTH6: '6m',
}
const StockDetail = ({stockDetail, callback}) => {
  
  const [activeTab, setActiveTab] = useState(Tab.DART);
  const [chartRange, setChartRange] = useState(ChartRange.MONTH1);
  const dispatch = useDispatch();
  const stockPost = useSelector(state => state.stock.detail.post);
  const stockStats = useSelector(state => state.stock.detail.stats);
  const stockData = useSelector(state => state.stock.detail.data);

  const {nm, cd} = stockDetail;
  const {cv, cr, rf, nv} = stockData;
  
  const refPopup = useRef();
  const refInner = useRef();
  const animationDuration = 420;

  const handleClickClose = useCallback((result) => {
    refPopup.current.classList.remove('active');
    if (callback) {
      setTimeout(() => {
        callback(result);
      }, animationDuration);
    }
  },[callback]);


  const refStockCode = useRef();
  const copyStockCode = useCallback(() => {
    refStockCode.current.type = 'text';
    refStockCode.current.select();
    document.execCommand("copy");
    refStockCode.current.type = 'hidden';
    dispatch(baseActions.showToast((<><span>{cd}</span> 종목코드가 클립보드에 복사되었습니다.</>)));
  },[cd, dispatch])

  
  const updownClass = useMemo(()=>{
    if (cv === 0) {
      return '';
    }
    if ([4, 5].includes(Number(rf))) {
      return 'down';
    }
    return 'up'
  },[rf, cv])


  const handleShortCut = useCallback(key => {
    switch(key) {
      case 'Escape':
        handleClickClose(false);
        break;
      default:
    }
  },[handleClickClose]);

  useShortCut(handleShortCut);
  useOutsideHandler({ 
    refDom: refInner, 
    onClick: handleClickClose.bind(null, false), 
  });


  const messageChartData = useMemo(()=>{
    switch(chartRange) {
      case ChartRange.MONTH1:
        return stockStats.message.month1;
      case ChartRange.MONTH3:
        return stockStats.message.month3;
      case ChartRange.MONTH6:
        return stockStats.message.month6;
      default:
        return [];
    }
  },[chartRange, stockStats]);


  const domPostList = useMemo(()=>{
    const list = activeTab === Tab.DART ? stockPost.dart : stockPost.news;
    if (list.length === 0) {
      return (
        <ul>
          <li className="noData">공시정보가 없습니다.</li>
        </ul>
      );
    }
    // console.log('list',list)
    switch(activeTab) {
      case Tab.DART:
        return (
          <ul>
            {list.map(item => (<li key={item.rcept_no}><a href={`https://dart.fss.or.kr/dsaf001/main.do?rcpNo=${item.rcept_no}`} target="_blank" rel="noreferrer" title={item.report_nm}>{item.report_nm}</a></li>))}
          </ul>
        );
      case Tab.NEWS:
        return (
          <ul>
            {list.map(item => (<li key={item.link}><a href={item.link} target="_blank" rel="noreferrer" title={util.removeTags(item.title)}>{util.removeTags(item.title)}</a></li>))}
          </ul>
        );
      default:
    }
  },[stockPost, activeTab]);

  
  useEffect(()=>{
    refPopup.current.classList.add('active');
  },[]);


  useEffect(()=>{
    dispatch(stockActions.getStockDetail({
      stock_code: cd,
      stock_name: nm,
      stockDetail: stockDetail,
    }));
  },[dispatch, cd, nm, stockDetail])

  useEffect(()=>{
    dispatch(baseActions.addPopupCnt());
    return () => {
      dispatch(baseActions.subPopupCnt());
    }
  },[dispatch]);


  return (
    
    <div className="stockPop" ref={refPopup}>
      <div className="inner" ref={refInner}>

        <div className="content">

          <div className="itm">
            <div className="header">
              <h3>{nm}</h3>
              <button type="button" onClick={copyStockCode}>종목코드 복사</button>
            </div>

            {/* <!-- 채널이슈, 종목검색 추이 차트 --> */}
            <div className="cont swiper-container">
              <Swiper
                spaceBetween={20}
                slidesPerView={1}
                pagination={{ clickable: true }}
              >
                <SwiperSlide key="pie">
                  <div className="data">
                    <p>{Number(nv || 0).toLocaleString('ko-KR')} <span className={`status ${updownClass}`}>{`${(cv || 0).toLocaleString('ko-KR')} (${(cr || 0)}%)`}</span></p>
                  </div>
                  <IssueChart data={stockStats.room} />
                </SwiperSlide>
                <SwiperSlide key="line">
                  <div className="data">
                    <p>{Number(nv || 0).toLocaleString('ko-KR')} <span className={`status ${updownClass}`}>{`${(cv || 0).toLocaleString('ko-KR')} (${(cr || 0)}%)`}</span></p>
                  </div>
                  <SearchChart data={messageChartData} />
                  <div className="chartSort">
                    <button type="button" onClick={setChartRange.bind(null, ChartRange.MONTH1)} className={chartRange === ChartRange.MONTH1 ? 'current' : null}>1M</button>
                    <button type="button" onClick={setChartRange.bind(null, ChartRange.MONTH3)} className={chartRange === ChartRange.MONTH3 ? 'current' : null}>3M</button>
                    <button type="button" onClick={setChartRange.bind(null, ChartRange.MONTH6)} className={chartRange === ChartRange.MONTH6 ? 'current' : null}>6M</button>
                  </div>
                </SwiperSlide>
                {/* <Pagination /> */}
              </Swiper>
            </div>
            {/* <!-- // 채널이슈, 종목검색 추이 차트 --> */}
          </div>

          <div className="itm">
            <div className="header">
              <h3>종목정보</h3>
            </div>

            <div className="cont">
              <div className="tab">
                <ul>
                  <li><button type="button" className={activeTab === Tab.DART ? "current" : ''} onClick={setActiveTab.bind(null, Tab.DART)}>공시정보</button></li>
                  <li><button type="button" className={activeTab === Tab.NEWS ? "current" : ''} onClick={setActiveTab.bind(null, Tab.NEWS)} >뉴스</button></li>
                </ul>
              </div>

              <div className="tabCon">
                {domPostList}
              </div>
            </div>
          </div>
        </div>

        <button type="button" className="close" onClick={handleClickClose}>닫기</button>
        <input type="hidden" ref={refStockCode} value={cd} readOnly/>
      </div>
    </div>
  )
}

export default StockDetail;